module.exports = __webpack_public_path__ + "static/media/cartoon_pm_jl.ef168159.png";